import * as React from 'react';

import { LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED } from '../../../../../../../shared/common/hooks/useUxFbPoll/constants';
import {
  getLocalStorageFiltersWereAppliedTwoTimes,
  setLocalStorageFiltersApplied,
} from '../../../../../../../shared/common/hooks/useUxFbPoll/localStorageUtils';
import { useFiltersContext } from '../../../../utils/useFiltersContext';

export const useHandleChange = () => {
  const { onChange, onApply } = useFiltersContext();

  const isLocalStorageFiltersWereAppliedTwoTimes = getLocalStorageFiltersWereAppliedTwoTimes(
    LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED,
  );

  return React.useCallback(
    (value: number) => {
      const gte = value;
      const lte = null;
      onChange({ action: 'setBeds', arguments: [gte > 1 ? gte : null, lte] });
      onApply();

      //Если фильтр был применен 2 раза, сохраняем значеине в LocalStorage
      if (!isLocalStorageFiltersWereAppliedTwoTimes) {
        setLocalStorageFiltersApplied(LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED);
      }
    },
    [onApply, onChange, isLocalStorageFiltersWereAppliedTwoTimes, setLocalStorageFiltersApplied],
  );
};
